import { render, staticRenderFns } from "./PageRenderer.vue?vue&type=template&id=1f08a489&scoped=true&"
import script from "./PageRenderer.vue?vue&type=script&lang=ts&"
export * from "./PageRenderer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f08a489",
  null
  
)

export default component.exports